import React, { Suspense } from "react";
import styled from "styled-components";
import { Typography } from "@shared/ui/Typography";
import { IconsKeyType } from "@shared/ui/Icon/icons";
import dynamic from "next/dynamic";

const Icon = dynamic(() => import("@shared/ui/Icon"), {
  suspense: true,
});

interface IProps {
  title: string;
  iconName: IconsKeyType;
  children: React.ReactNode;
}

export function ContactInfo({ title, children, iconName }: IProps) {
  return (
    <StyledView>
      <Suspense fallback="icon">
        <Icon name={iconName} iconColor="primary_red" iconSize={32} />
      </Suspense>
      <div>
        <StyledTitle tag="h4" fontSize="1.8rem" weight={500}>
          {title}
        </StyledTitle>
        {children}
      </div>
    </StyledView>
  );
}

const StyledView = styled.div`
  display: grid;
  grid-gap: 1.6rem;
  grid-auto-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledTitle = styled(Typography)`
  margin-bottom: 0.8rem;
`;
